import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { Box, NumberFieldC } from 'components'
import { useOrderStore } from 'modules/orders/store'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { formatCurrency, isDivision60User } from 'utils'
import { RecalculeAlert } from '../../recalculeAlert'
import InstallmentsView from '../payment/installments'
import { ProposalValidity } from './proposalValidity'

export default function Summary() {
  const form = useOrderStore.useForm()
  const { setValue, watch } = useFormContext()
  const [showCommissionInfo, setShowCommissionInfo] = useState(true)
  const sellerDivision = watch('seller')?.division

  const isDivision60 = isDivision60User(sellerDivision)
  const commissionPercent = Number(watch('commissionPercent') || 0)
  const totalCommissionGenerated =
    ((Number(form?.total?.total || 0) || 0) * commissionPercent) / 100

  useEffect(() => {
    if (!isDivision60) return
    const normalized = Math.max(0, Math.min(5, commissionPercent))
    if (normalized !== commissionPercent) {
      setValue('commissionPercent', normalized, { shouldValidate: true })
    }
  }, [commissionPercent, isDivision60, setValue])

  const handleToggleCommissionVisibility = () => {
    const nextVisibility = !showCommissionInfo

    if (!nextVisibility) {
      setValue('commissionPercent', 0, {
        shouldValidate: true,
        shouldDirty: true
      })
    }

    setShowCommissionInfo(nextVisibility)
  }

  return (
    <Box style={{ width: '100%', padding: 12 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RecalculeAlert />
        </Grid>

        <Grid item xs={12}>
          <ProposalValidity />
        </Grid>

        <Grid item xs={6}>
          <NumberFieldC name="totalDiscount" label="Desconto R$" prefix="R$ " />
        </Grid>

        <Grid item xs={6}>
          <NumberFieldC name="totalExpenses" label="Despesas R$" prefix="R$ " />
        </Grid>

        {isDivision60 && (
          <Grid item xs={12}>
            <Box
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                height: 28
              }}
            >
              <Tooltip
                title={
                  showCommissionInfo ? 'Ocultar comissão' : 'Mostrar comissão'
                }
              >
                <IconButton
                  size="small"
                  onClick={handleToggleCommissionVisibility}
                  aria-label={
                    showCommissionInfo ? 'Ocultar comissão' : 'Mostrar comissão'
                  }
                >
                  {showCommissionInfo ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
        )}

        {isDivision60 && (
          <Grid item xs={6}>
            <Box
              style={{
                visibility: showCommissionInfo ? 'visible' : 'hidden'
              }}
            >
              <NumberFieldC
                name="commissionPercent"
                label="Percentual de Comissão (%)"
                suffix="%"
              />
            </Box>
          </Grid>
        )}

        {isDivision60 && (
          <Grid item xs={6}>
            <Box
              style={{
                visibility: showCommissionInfo ? 'visible' : 'hidden',
                border: '1px solid #e5e7eb',
                borderRadius: 4,
                padding: '4px 10px',
                height: 36,
                boxSizing: 'border-box',
                backgroundColor: '#fafafa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Total Comissão
              </Typography>
              <Typography variant="subtitle2" fontWeight={600}>
                {formatCurrency(totalCommissionGenerated)}
              </Typography>
            </Box>
          </Grid>
        )}

        {/* <Grid item xs={12}>
          <TextFieldC
            name="observation"
            label="Observação NF"
            multiline
            rows={3}
          />
        </Grid> */}

        <InstallmentsView />
      </Grid>
    </Box>
  )
}
